import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["popup"]

  declare readonly popupTarget: HTMLElement
  declare readonly hasPopupTarget: boolean

  toggle(): void {
    if (this.hasPopupTarget) {
      this.popupTarget.classList.toggle("hidden")
    }
  }
}
